module.exports = __webpack_public_path__ + "2d554424b763bed9142fba7aaf41d8fc.svg";